const NOT_CONFIGURED = '000'
const PENDING_PARENTS = '001'
const IN_PROCESS = '002'
const FINISHED = '003'
const ERROR = '004'

export default {
  NOT_CONFIGURED,
  PENDING_PARENTS,
  IN_PROCESS,
  FINISHED,
  ERROR
}
